import { render, staticRenderFns } from "./WAChat.vue?vue&type=template&id=161c7b0e&scoped=true&"
import script from "./WAChat.vue?vue&type=script&lang=js&"
export * from "./WAChat.vue?vue&type=script&lang=js&"
import style0 from "./WAChat.vue?vue&type=style&index=0&id=161c7b0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161c7b0e",
  null
  
)

export default component.exports